import { createSelector } from 'reselect'

import { selectFinancialCockpitState } from './selectFinancialCockpitState'

export const selectAvailableCockpitCurrencies = createSelector(
  [selectFinancialCockpitState],
  ({ availableCurrencies }) => availableCurrencies
)
